export const validate = (data, type) => {
  const errors = {};

  if (type === "login") {
    // .toString().trim()
    if (!data.username.toString().trim()) {
      errors.username = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.username;
    }

    if (!data.password.toString().trim()) {
      errors.password = "لطفا این قسمت را خالی نگذارید.";
    } else if (data.password.toString().trim().length < 8) {
      errors.password = "رمز عبور باید حداقل ۸ کاراکتر یا بیشتر باشد.";
    } else {
      delete errors.password;
    }
  }

  if (type === "introduce-business") {
    if (!data.engName.toString().trim()) {
      errors.engName = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.engName;
    }
    if (!data.countryy.toString().trim()) {
      errors.countryy = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.countryy;
    }
    if (!data.provincee.toString().trim()) {
      errors.provincee = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.provincee;
    }
    if (!data.cityy.toString().trim()) {
      errors.cityy = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.cityy;
    }
  }

  if (type === "register-business-s1") {
    if (!data.EnTitle.toString().trim()) {
      errors.EnTitle = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.EnTitle;
    }
    if (!data.EnJobTitle.toString().trim()) {
      errors.EnJobTitle = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.EnJobTitle;
    }
    // if (!rbdata2.toString().trim()) {
    //   errors.countryy = "لطفا این قسمت را خالی نگذارید.";
    // } else {
    //   delete errors.countryy;
    // }
    // if (!data.provincee.toString().trim()) {
    //   errors.provincee = "لطفا این قسمت را خالی نگذارید.";
    // } else {
    //   delete errors.provincee;
    // }
    // if (!data.cityy.toString().trim()) {
    //   errors.cityy = "لطفا این قسمت را خالی نگذارید.";
    // } else {
    //   delete errors.cityy;
    // }
  }
  if (type === "register-business-s4") {
    if (!data.country.toString().trim()) {
      errors.country = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.country;
    }
  }
  if (type === "register-business-s2") {
    if (!data.categoryy.toString().trim()) {
      errors.categoryy = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.categoryy;
    }
  }

  if (type === "register-business-s5") {
    if (
      (!data.phonee1 ||
        (data.phonee1 == "" && !data.phonee1.toString().trim())) &&
      (!data.phonee2 ||
        (data.phonee2 == "" && !data.phonee2.toString().trim())) &&
      (!data.phonee3 ||
        (data.phonee3 == "" && !data.phonee3.toString().trim())) &&
      (!data.phonee4 ||
        (data.phonee4 == "" && !data.phonee4.toString().trim())) &&
      (!data.phonee5 ||
        (data.phonee5 == "" && !data.phonee5.toString().trim())) &&
      (!data.phonee6 || (data.phonee6 == "" && !data.phonee6.toString().trim()))
    ) {
      errors.phonee1 = "لطفا یکی از فیلد ها را پر کنید.";
      errors.phonee2 = "لطفا یکی از فیلد ها را پر کنید.";
      errors.phonee3 = "لطفا یکی از فیلد ها را پر کنید.";
      errors.phonee4 = "لطفا یکی از فیلد ها را پر کنید.";
      errors.phonee6 = "لطفا یکی از فیلد ها را پر کنید.";
      errors.phonee5 = "لطفا یکی از فیلد ها را پر کنید.";
    } else {
      delete errors.phonee1;
      delete errors.phonee2;
      delete errors.phonee3;
      delete errors.phonee4;
      // delete errors.phonee5;
      // delete errors.phonee6;

      if (!data.phonee5 == "" && !/\S+@\S+\.\S+/.test(data.phonee5)) {
        errors.phonee5 = "آدرس ایمیل نامعتبر است.";
      } else {
        delete errors.phonee5;
      }
      if (!data.phonee6 == "" && !/\S+\.\S+/.test(data.phonee6)) {
        errors.phonee6 = "آدرس سایت نامعتبر است.";
      } else {
        delete errors.phonee6;
      }
    }
    // console.log(errors.phonee1);
  }
  // step 8 request site
  if (type === "requestSite") {
    if (!data.firstname.toString().trim()) {
      errors.firstname = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.firstname;
    }
    if (!data.lastname.toString().trim()) {
      errors.lastname = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.lastname;
    }
    if (!data.phone.toString().trim()) {
      errors.phone = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.phone;
    }
    if (!data.email) {
      errors.email = "لطفا این قسمت را خالی نگذارید.";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "آدرس ایمیل نامعتبر است.";
    } else {
      delete errors.email;
    }
  }

  // forget pass
  if (type === "forget-pass") {
    // .toString().trim()
    if (!data.email) {
      errors.email = "لطفا این قسمت را خالی نگذارید.";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "آدرس ایمیل نامعتبر است.";
    } else {
      delete errors.email;
    }
  }
  // change pass
  if (type === "change-pass") {
    if (!data.password.toString().trim()) {
      errors.password = "لطفا این قسمت را خالی نگذارید.";
    } else if (data.password.toString().trim().length < 8) {
      errors.password = "رمز عبور باید حداقل ۸ کاراکتر یا بیشتر باشد.";
    } else {
      delete errors.password;
    }

    if (!data.repeatPassword.toString().trim()) {
      errors.repeatPassword = "لطفا این قسمت را خالی نگذارید.";
    } else if (data.password !== data.repeatPassword) {
      errors.repeatPassword = "تکرار رمز عبور همخوانی ندارد.";
    } else if (data.repeatPassword.toString().trim().length < 8) {
      errors.repeatPassword = "رمز عبور باید حداقل ۸ کاراکتر یا بیشتر باشد.";
    } else {
      delete errors.repeatPassword;
    }
  }
  // sign up
  if (type === "signup") {
    if (!data.Firstname.toString().trim()) {
      errors.Firstname = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.Firstname;
    }

    if (!data.Lastname.toString().trim()) {
      errors.Lastname = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.Lastname;
    }
    if (!data.Email) {
      errors.Email = "لطفا این قسمت را خالی نگذارید.";
    } else if (!/\S+@\S+\.\S+/.test(data.Email)) {
      errors.Email = "آدرس ایمیل نامعتبر است.";
    } else {
      delete errors.Email;
    }
    if (!data.username.toString().trim()) {
      errors.username = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.username;
    }
    if (!data.isAccepted) {
      errors.isAccepted = "لطفا قوانین را تایید کنید.";
    } else {
      delete errors.isAccepted;
    }
    if (!data.Password.toString().trim()) {
      errors.Password = "لطفا این قسمت را خالی نگذارید.";
    } else if (data.Password.toString().trim().length < 8) {
      errors.Password = "رمز عبور باید حداقل ۸ کاراکتر یا بیشتر باشد.";
    } else {
      delete errors.Password;
    }
  }

  if (type === "business-tablighat") {
    if (!data.email) {
      errors.email = "لطفا این قسمت را خالی نگذارید.";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "آدرس ایمیل نامعتبر است.";
    } else {
      delete errors.email;
    }
  }
  // business-setting-info
  if (type === "business-setting-info") {
    if (!data.email) {
      errors.email = "لطفا این قسمت را خالی نگذارید.";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "آدرس ایمیل نامعتبر است.";
    } else {
      delete errors.email;
    }

    if (!data.fname) {
      errors.fname = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.fname;
    }
    if (!data.lname) {
      errors.lname = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.lname;
    }
    if (!data.username) {
      errors.username = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.username;
    }
  }

  // change pass dashboard
  if (type === "business-setting-pass") {
    if (!data.OldPassword.toString().trim()) {
      errors.OldPassword = "لطفا این قسمت را خالی نگذارید.";
    } else if (data.OldPassword.toString().trim().length < 8) {
      errors.OldPassword = "رمز عبور باید حداقل ۸ کاراکتر یا بیشتر باشد.";
    } else {
      delete errors.OldPassword;
    }

    if (!data.NewPassword.toString().trim()) {
      errors.NewPassword = "لطفا این قسمت را خالی نگذارید.";
    } else if (data.NewPassword.toString().trim().length < 8) {
      errors.NewPassword = "رمز عبور باید حداقل ۸ کاراکتر یا بیشتر باشد.";
    } else {
      delete errors.NewPassword;
    }

    if (!data.RepeatNewPassword.toString().trim()) {
      errors.RepeatNewPassword = "لطفا این قسمت را خالی نگذارید.";
    } else if (data.NewPassword !== data.RepeatNewPassword) {
      errors.RepeatNewPassword = "تکرار رمز عبور همخوانی ندارد.";
    } else if (data.RepeatNewPassword.toString().trim().length < 8) {
      errors.RepeatNewPassword = "رمز عبور باید حداقل ۸ کاراکتر یا بیشتر باشد.";
    } else {
      delete errors.RepeatNewPassword;
    }
  }

  // dashboard
  if (type === "dashboard-s1-1") {
    if (!data.EnName.toString().trim()) {
      errors.EnName = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.EnName;
    }
  }
  if (type === "dashboard-s1-2") {
    if (!data.EnJob.toString().trim()) {
      errors.EnJob = "لطفا این قسمت را خالی نگذارید.";
    } else {
      delete errors.EnJob;
    }
  }

  return errors;
};
